import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const WorkOutlined = ({ size = 36, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#clip0_782_5003)">
      <Path
        d="M19.04 8.12988C19.81 8.12988 20.43 8.74988 20.43 9.51988V17.1099C20.43 17.8799 19.81 18.4999 19.04 18.4999H4.89C4.12 18.4999 3.5 17.8799 3.5 17.1099V9.51988C3.5 8.74988 4.12 8.12988 4.89 8.12988H19.04ZM11.15 16.1999H12.78C13.61 16.1999 14.28 15.5299 14.28 14.6999V13.0699C14.28 12.2399 13.61 11.5699 12.78 11.5699H11.15C10.32 11.5699 9.65 12.2399 9.65 13.0699V14.6999C9.65 15.5299 10.32 16.1999 11.15 16.1999ZM19.04 6.62988H4.89C3.29 6.62988 2 7.92988 2 9.51988V17.1099C2 18.7099 3.29 19.9999 4.89 19.9999H19.04C20.63 19.9999 21.93 18.7099 21.93 17.1099V9.51988C21.93 7.92988 20.63 6.62988 19.04 6.62988ZM11.15 14.6999V13.0699H12.78V14.6999H11.15Z"
        fill={color}
      />
      <Path
        d="M14.2702 5.5L14.5702 6.66H9.6502L9.9502 5.5H14.2702ZM14.4602 4H9.7502C9.1902 4 8.7002 4.31 8.5902 4.74L7.7002 8.17H16.4902L15.6002 4.74C15.4902 4.31 15.0002 4 14.4402 4H14.4602Z"
        fill={color}
      />
      <Path
        d="M11.7002 14.7002H12.1902C12.1202 14.7402 12.0402 14.7502 11.9602 14.7502C11.8902 14.7502 11.8102 14.7402 11.7302 14.7102H11.7002V14.7002Z"
        fill={color}
      />
      <Path
        d="M21.99 10.7701C21.99 10.7701 21.96 10.7 21.93 10.66C21.78 10.34 21.4 10.17 21.05 10.29L14.28 12.46V12.32C14.28 11.91 13.94 11.57 13.53 11.57H10.4C9.99 11.57 9.65 11.91 9.65 12.32V12.46L2.97 10.29C2.57 10.16 2.15 10.3701 2.02 10.7701C2.01 10.8201 2 10.87 2 10.92V11.07C2.02 11.36 2.21 11.61 2.5 11.71L9.65 14.03V15.45C9.65 15.87 9.99 16.2001 10.4 16.2001H13.53C13.94 16.2001 14.28 15.87 14.28 15.45V14.04L21.51 11.71C21.69 11.65 21.84 11.52 21.93 11.36C22.03 11.19 22.06 10.9701 21.99 10.7701ZM12.78 14.7H11.15V13.07H12.78V14.7Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_782_5003">
        <Rect width={`${size}px`} height={`${size}px`} fill={color} />
      </ClipPath>
    </Defs>
  </Svg>
)

export default WorkOutlined
